import React from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import Conditions from './Conditions'
import PriceLevels from './PriceLevels'

const styles = theme => ({
  root: {
  
  },
});

class Filters extends React.Component {
//export default class IdkTableFormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    const { classes, commonStore, ...otherProps } = this.props

    return (
        <div className={classes.root}>
          <Conditions {...otherProps} />
          <PriceLevels {...otherProps} />
        </div>
    );
  }
}

Filters.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Filters);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/Filters/index.js